const Slugger = require('haikunator');
const slugger = new Slugger({
  defaults: {
    tokenLength: 3,
    tokenChars: 'ABCDEF0123456789',
  },
});

module.exports = slugger.haikunate.bind(slugger);



//////////////////
// WEBPACK FOOTER
// ./~/jsbin-id/index.js
// module id = 59
// module chunks = 10 11